__webpack_require__.p = "/yxmgt/";